import format from "date-fns/format";

import { getNextPaidSubscription } from "@/utils/getNextPaidSubscription";

export function showSubscriptionToast(subscriptions, toast) {
  const activeSubscription = getNextPaidSubscription(subscriptions);

  if (!activeSubscription) {
    toast.error(
      "Продлите подписку для использования\nполного функционала сервиса",
    );
  } else {
    const formattedDate = format(
      new Date(activeSubscription.startDate),

      "dd.MM.yyyy",
    );

    toast.success(`Ваша подписка стартует с ${formattedDate}`);
  }
}
